import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'

Vue.use(VueAxios, axios);

Vue.axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

Vue.use(VueAuth, {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    rolesVar: 'id',
    loginData: { url: 'api/auth/login', method: 'POST' },
    fetchData: { url: 'api/auth/me', method: 'GET', fetchUser: false, redirect: '/'},
    refreshData: { url: 'api/auth/refresh', method: 'GET' },
    logoutData: { url: 'api/auth/logout', method: 'GET' }
});
